import { SelectedFilterOption } from '../model/filter-criteria-item.model';

// TODO rename, or make params generic, or use accessor param pattern
export function toggleObjectsForArray(
    filterCriteriaArray: SelectedFilterOption[],
    value: SelectedFilterOption,
): SelectedFilterOption[] {
    const keys = Object.keys(value);
    const index = filterCriteriaArray.findIndex((item) =>
        keys.every((key) => item[key] === value[key]),
    );
    const newFilterCriteriaArray = [...filterCriteriaArray];
    if (index >= 0) {
        newFilterCriteriaArray.splice(index, 1);
    } else {
        newFilterCriteriaArray.push(value);
    }
    return newFilterCriteriaArray;
}
